<template>
  <div class="d-flex all-width align-center justify-space-between gap-3" data-testid="request-summary__container">
    <v-card
      :class="['task-tab total_task_tab total_task-border all-width d-flex align-center justify-space-between radius-small shadow-off pa-4', { 'request-summary__card--selected': selectedTab === null }]"
      @click="$emit('select-tab', null)"
      data-testid="request-summary__total-card"
    >
      <div class="d-flex align-center gap-3" data-testid="request-summary__total-group">
        <span class="status-empty-indicator status-indicator-width-height-20"></span>
        <p class="" data-testid="request-summary__total-title">Total Request</p>
      </div>
      <p class="font-weight-bold" data-testid="request-summary__total-value">{{ totalRequests || 0 }}</p>
    </v-card>

    <v-card
      :class="['task-tab pending_sub_tab pending-task-border all-width d-flex align-center justify-space-between radius-small shadow-off pa-4', { 'request-summary__card--selected': selectedTab === 0 }]"
      @click="$emit('select-tab', 0)"
      data-testid="request-summary__pending-card"
    >
      <div class="d-flex align-center gap-3" data-testid="request-summary__pending-group">
        <span class="status-empty-indicator status-indicator-width-height-20"></span>
        <p class="" data-testid="request-summary__pending-title">Pending Submission</p>
      </div>
      <p class="font-weight-bold" data-testid="request-summary__pending-value">{{ summaryRequested || 0 }}</p>
    </v-card>

    <v-card
      :class="['task-tab pending_app_tab approve-task-border all-width d-flex align-center justify-space-between radius-small shadow-off pa-4', { 'request-summary__card--selected': selectedTab === 1 }]"
      @click="$emit('select-tab', 1)"
      data-testid="request-summary__approval-card"
    >
      <div class="d-flex align-center gap-3" data-testid="request-summary__approval-group">
        <span class="status-empty-indicator status-indicator-width-height-20"></span>
        <p class="" data-testid="request-summary__approval-title">Pending Approvals</p>
      </div>
      <p class="font-weight-bold" data-testid="request-summary__approval-value">{{ summaryPending || 0 }}</p>
    </v-card>

    <v-card
      :class="['task-tab closed_tab closed-task-border all-width d-flex align-center justify-space-between radius-small shadow-off pa-4', { 'request-summary__card--selected': selectedTab === 2 }]"
      @click="$emit('select-tab', 2)"
      data-testid="request-summary__closed-card"
    >
      <div class="d-flex align-center gap-3" data-testid="request-summary__closed-group">
        <span class="status-empty-indicator status-indicator-width-height-20"></span>
        <p class="" data-testid="request-summary__closed-title">Approved</p>
      </div>
      <p class="font-weight-bold" data-testid="request-summary__closed-value">{{ summaryClosed || 0 }}</p>
    </v-card>

    <v-card
      :class="['task-tab tb_tab_border error-tab error-text all-width d-flex align-center justify-space-between radius-small shadow-off pa-4', { 'request-summary__card--selected': selectedTab === -1 }]"
      @click="$emit('select-tab', -1)"
      data-testid="request-summary__cancelled-card"
    >
      <div class="d-flex align-center gap-3" data-testid="request-summary__cancelled-group">
        <span class="status-empty-indicator status-indicator-width-height-20"></span>
        <p class="" data-testid="request-summary__cancelled-title">Cancelled</p>
      </div>
      <p class="font-weight-bold" data-testid="request-summary__cancelled-value">{{ summaryCancelled || 0 }}</p>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'RequestSummaryCards',
  props: {
    /**
     * Currently selected tab/stage for filtering
     * null = all, 0 = pending submission, 1 = pending approval, 2 = approved, -1 = cancelled
     */
    selectedTab: {
      type: [Number, null],
      default: null,
    },
    totalRequests: {
      type: Number,
      default: 0,
    },
    summaryRequested: {
      type: Number,
      default: 0,
    },
    summaryPending: {
      type: Number,
      default: 0,
    },
    summaryClosed: {
      type: Number,
      default: 0,
    },
    summaryCancelled: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
.request-summary__card--selected {
  background-color: var(--color-surface-subtle, rgba(0, 0, 0, 0.03)) !important;
  box-shadow: 0 0 0 1px var(--color-border-subtle, rgba(0, 0, 0, 0.1)) !important;
}
</style>
